import { useNavigate } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

export default function TemplateRulesCard() {
  const navigate = useNavigate();

  return (
    <Card id="template-rules">
      <CardHeader>
        <CardTitle>Template Rules</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex flex-col gap-4">
          <p className="text-sm text-muted-foreground">
            Configure which content templates and sections are available for your website.
          </p>
          <Button
            variant="outline"
            onClick={() => navigate("/template-rules")}
            className="w-fit"
          >
            Configure Template Rules
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
